var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Box, Text } from '@bfa/common-ui';
import React, { useState } from 'react';
import TermsOfServiceModal from './TermsOfServiceModal';
var TermsOfService = function (_a) {
    var shortDescriptionOfTheTermsOfServiceLink = _a.shortDescriptionOfTheTermsOfServiceLink, termsOfServiceLinkText = _a.termsOfServiceLinkText, termsOfServiceText = _a.termsOfServiceText, disableTOSModal = _a.disableTOSModal;
    var _b = __read(useState(false), 2), showModal = _b[0], setShowModal = _b[1];
    var onClick = function () { return !disableTOSModal && setShowModal(!showModal); };
    var formatLinkingText = " ".concat(termsOfServiceLinkText, ".");
    return (React.createElement(Box, { fontSize: "1.2rem", color: "#767676", mt: "1.5rem", textAlign: "center" },
        React.createElement(Text, { as: "span" },
            shortDescriptionOfTheTermsOfServiceLink,
            React.createElement(Text, { as: "span", color: "#EF447F", onClick: onClick }, formatLinkingText)),
        React.createElement(TermsOfServiceModal, { showModal: showModal, onClick: onClick, text: termsOfServiceText })));
};
export default TermsOfService;
